<template lang="html">

  <div class="newOrder">

    <breadcrumb :nameSection="nameSection" :listRoutes="listRoutes" :activeRoute="activeRoute"></breadcrumb>

    <div v-if="dataPackage">

      <div class="orden-subtitulo text-title">

        <h1>Paquete {{dataPackage.attributes.package_name}}</h1>

        <div class="rr">
          <a href="#" class="btn btn-clean btn-clean-white" @click="backPage">
            <i class="fas fa-long-arrow-alt-left"></i>
            Volver
          </a>
        </div>

      </div>

      <div class="details-tab">

        <div class="detalle-inci">

          <span>Información del paquete</span>

          <div class="resumen_orden">

            <div class="resumen_titulo">

              <h1>Peso aproximado (lb):</h1>

            </div>

            <div class="resumen_content" >

              <h1> {{dataPackage.attributes.partial_weight}}</h1>

            </div>

          </div>

          
          

          <div class="resumen_orden">

            <div class="resumen_titulo">

              <h1>Ejemplares originales:</h1>

            </div>

            <div class="resumen_content" >

              <h1>{{dataPackage.attributes.items_from_order}}</h1>

            </div>

          </div>

          <div class="resumen_orden" >

            <div class="resumen_titulo ">

              <h1>Ejemplares de otros paquetes: </h1>

            </div>

            <div class="resumen_content" >

              <h1>{{dataPackage.attributes.items_from_reposition}}</h1>
              <button v-if="dataPackage.attributes.items_from_reposition > 0" type="button" class="btn "   @click="showRepositionItemsDetail">
                Ver detalles
              </button>

            </div>

          </div>

          <div class="resumen_orden">

            <div class="resumen_titulo">

              <h1>Ejemplares totales:</h1>

            </div>

            <div class="resumen_content" >

              <h1>{{dataPackage.attributes.number_of_items}}</h1>

            </div>

          </div>

          


        </div>

         <div class="detalle-inci">

            <div v-if="dataPackage.attributes.evaluated == 1">

              <span>Detalle de evaluación de paquete</span>

              <div class="resumen_orden">

                <div class="resumen_titulo">

                  <h1>N° items evaluados:</h1>

                </div>

                <div class="resumen_content" >

                  <h1>{{dataPackage.attributes.real_number_of_items}}</h1>

                </div>

              </div>

              <div class="resumen_orden">

                <div class="resumen_titulo">

                  <h1>N° items correctos:</h1>

                </div>

                <div class="resumen_content" >

                  <h1>{{dataPackage.attributes.number_of_items_correct}}</h1>

                </div>

              </div>

              <div class="si-incidencias-container" v-if="dataPackage.attributes.incidents.length> 0">

                <div class="resumen_orden">

                    <div class="resumen_titulo mensaje-inci si-incidencias">

                     <h1><i class="fas fa-times"></i>Se generaron <span>{{dataPackage.attributes.incidents.length}}</span> incidencias</h1>

                    </div>

                </div>

                <div class="" v-for="incident of dataPackage.attributes.incidents">



                  <div class="inci-container" v-if="incident.attributes.clusterable_type == 'different_quantity'">

                    <div class="resumen_orden">

                      <h1>Descripción: </h1>

                      <h1>{{incident.attributes.description}}</h1>

                    </div>

                    <div class="resumen_orden">

                      <h1>Tipo: </h1>

                      <h1 v-if="incident.attributes.clusterable.attributes.delta_type==1"> Déficit</h1>

                      <h1 v-else-if="incident.attributes.clusterable.attributes.delta_type==2">Exceso</h1>

                      <h1 v-else> No definido</h1>

                    </div>

                    <div class="resumen_orden">

                      <h1>Items correctos sobre totales en el paquete: </h1>

                      <h1> {{incident.attributes.clusterable.attributes.correct_items + "/" +incident.attributes.clusterable.attributes.total_items}}</h1>

                    </div>

                    <div class="resumen_orden">

                      <h1> {{incident.attributes.clusterable.attributes.delta_type==1?'Ejemplares a reponer:':'Ejemplares en exceso'}} </h1>

                      <div v-if="incident.attributes.clusterable.attributes.delta_type==1">

                        <h1> {{ deficitItems }}</h1>

                        <button v-if="incident.attributes.clusterable.attributes.delta_type==1" type="button" class="btn "   @click="showDeficitIncidentItemsDetail(incident.id)">
                          Ver detalles
                        </button>

                      </div>

                      <div  v-else>

                         <p> {{ (parseInt(incident.attributes.clusterable.attributes.total_items)- parseInt(incident.attributes.clusterable.attributes.correct_items))*(-1)}}</p>

                      </div>

                    </div>

                  </div>

                  <div class="inci-container" v-if="incident.attributes.clusterable_type == 'waste'">

                    <div class="resumen_orden">

                      <h1>Descripción: </h1>

                      <h1>{{incident.attributes.description}}</h1>

                    </div>

                    <div class="resumen_orden">

                      <h1>Tipo: </h1>

                      <h1 v-if="incident.attributes.clusterable.attributes.correct_product_flag==1" > De merma del producto correcto</h1>
                      <h1 v-else > De merma del producto equivocado</h1>
                    </div>

                    <div class="resumen_orden">

                     

                      <h1 >Ejemplares:</h1>

                      <h1>{{incident.attributes.clusterable.attributes.wasted_items}} </h1>

                    </div>

                  </div>

                  <div class="inci-container" v-if="incident.attributes.clusterable_type == 'wrong'">

                    <div class="resumen_orden">

                      <h1>Descripción: </h1>

                      <h1>{{incident.attributes.description}}</h1>

                    </div>

                    <div class="resumen_orden">

                      <h1>Tipo: </h1>

                      <h1 v-if="incident.attributes.clusterable.attributes.wasted_flag==0"> De producto equivocado sin merma</h1>
                      <h1 v-else> De producto equivocado con merma</h1>

                    </div>

                    <div class="resumen_orden">

                      <h1>Ejemplares: </h1>

                      

                      <h1>{{incident.attributes.clusterable.attributes.wrong_items}}</h1>

                    </div>

                  </div>

                </div>

              </div>

              <div v-else-if="dataPackage.attributes.incidents.length == 0">

                <div class="resumen_orden">

                  <div class="resumen_titulo mensaje-inci no-incidencias">

                    <h1><i class="fas fa-check"></i>No se generaron incidencias</h1>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>


    </div>

    <b-modal hide-footer hide-header centered id="modalDetailItemsFail" ref="modalDetailItemsFail">
      <div class="modal-Content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Detalle de ejemplares del paquete actual repuestos en nuevos paquetes</h5>
          <button type="button" class="close" aria-label="Close" @click="hideModalDetailItemsFail">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-scroll" id="modal-body">

         


          <div v-for="packageRepositionLevel of deficitPackageRepositions">
            <hr style="height:1px;border:none;color:#333;background-color:#333;">
            <hr style="height:1px;border:none;color:#333;background-color:#333;">
           
            <div class="resumen_orden">
              <div class="resumen_titulo">
                <h4>REPUESTOS POR  {{packageRepositionLevel.level|cardinalityUpper}} VEZ </h4>
              </div>
           </div>
            <div v-if="packageRepositionLevel.packageReposition.attributes.packages_info_free_by!=null && packageRepositionLevel.packageReposition.attributes.packages_info_free_by.length > 0"   >


              <div  v-for="packageInfo of packageRepositionLevel.packageReposition.attributes.packages_info_free_by">
                <hr>
                <div class="resumen_orden">

                  <div class="resumen_titulo">

                    <h1>Paquete nuevo </h1>

                  </div>

                  <div class="resumen_content" >

                    <h1><router-link :to="{ name: 'show-package',params: { id: packageInfo.attributes.id }}">{{packageInfo.attributes.package_name }}</router-link> </h1>

                  </div>

                </div>

                <div class="resumen_orden">

                  <div class="resumen_titulo">

                    <h1>Ejemplares repuestos</h1>

                  </div>

                  <div class="resumen_content" >

                    <h1>
                    {{packageInfo.attributes.free_detail.free_items}}</h1>

                  </div>

                </div>

                  
              </div>



              
            </div>
            <div v-else>
              <p>Aún no se han repuesto ejemplares</p>
            </div>
            

            <hr style="height:1px;border:none;color:#333;background-color:#333;">
            
            <div class="resumen_orden">
              <div class="resumen_titulo">
                <h4>Ejemplares repuestos por {{packageRepositionLevel.level|cardinality}} vez reemplazados</h4>
              </div>
              <div class="resumen_content" >
                <h4>
                    {{packageRepositionLevel.items_replaced}}</h4>
              </div>

              

            </div>
            <div class="resumen_orden">
              <div class="resumen_titulo">
                <h4>Ejemplares repuestos por {{packageRepositionLevel.level|cardinality}} vez pendientes </h4>
              </div>
              <div class="resumen_content" >
                <h4>
                    {{packageRepositionLevel.packageReposition.attributes.pendient_items}}</h4>
              </div>

              

            </div>
            <hr>
            <div class="resumen_orden">
              <div class="resumen_titulo">
                <h4>Subtotal ejemplares repuestos por {{packageRepositionLevel.level|cardinality}} vez  </h4>
              </div>
              <div class="resumen_content" >
                <h4>
                    {{parseInt(packageRepositionLevel.packageReposition.attributes.pendient_items)+ parseInt(packageRepositionLevel.items_replaced)}}</h4>
              </div>

              

            </div>
            

              

            

          </div>

          <hr style="height:1px;border:none;color:#333;background-color:#333;">
          <hr style="height:1px;border:none;color:#333;background-color:#333;">
          <hr style="height:1px;border:none;color:#333;background-color:#333;">

          <div class="resumen_orden">
            <div class="resumen_titulo">
              <h4>Total ejemplares a reponer en nuevos paquetes  </h4>
            </div>
            <div class="resumen_content" >
              <h4>
                  {{deficitItems}}</h4>
            </div>
          </div>

        </div>

        <div class="modal-footer text-center">
          <button
            type="button"
            class="btn btn-primary btn-lg"
            @click="hideModalDetailItemsFail()"
          >Cerrar</button>
        </div>
      </div>
    </b-modal>

    <b-modal hide-footer hide-header centered id="modalDetailReposition" ref="modalDetailReposition">
      <div class="modal-Content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Detalle de ejemplares de otros paquetes repuestos en el paquete actual</h5>
          <button type="button" class="close" aria-label="Close" @click="hideModalDetailReposition">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-scroll" id="modal-body">

          <div v-for="packageRepositionLevel of packageRepositions">
            <hr style="height:1px;border:none;color:#333;background-color:#333;">
            <hr style="height:1px;border:none;color:#333;background-color:#333;">
           
            <div class="resumen_orden">
              <div class="resumen_titulo">
                <h4>REPUESTOS POR  {{packageRepositionLevel.level|cardinalityUpper}} VEZ </h4>
              </div>
              

              

            </div>
    
            <div  v-for="packageReposition of packageRepositionLevel.packageRepositions">
                <hr>
                <div class="resumen_orden">

                  <div class="resumen_titulo">

                    <h1>Paquete de origen </h1>

                  </div>

                  <div class="resumen_content" >

                    <h1><router-link :to="{ name: 'show-package',params: { id: packageReposition.attributes.package.id }}">{{packageReposition.attributes.package.attributes.package_name }}</router-link> </h1>

                  </div>

                </div>

                <div class="resumen_orden">

                  <div class="resumen_titulo">

                    <h1>Ejemplares repuestos</h1>

                  </div>

                  <div class="resumen_content" >

                    <h1>
                    {{packageReposition.attributes.free_detail.free_items}}</h1>

                  </div>

                </div>

                
            </div>

            <hr style="height:1px;border:none;color:#333;background-color:#333;">
            
            <div class="resumen_orden">
              <div class="resumen_titulo">
                <h4>Subtotal ejemplares repuestos por {{packageRepositionLevel.level|cardinality}} vez </h4>
              </div>
              <div class="resumen_content" >
                <h4>
                    {{packageRepositionLevel.subtotal}}</h4>
              </div>

              

            </div>
            

              

            

          </div>

          <hr style="height:1px;border:none;color:#333;background-color:#333;">
          <hr style="height:1px;border:none;color:#333;background-color:#333;">
          <hr style="height:1px;border:none;color:#333;background-color:#333;">

          <div class="resumen_orden">
            <div class="resumen_titulo">
              <h4>Total ejemplares de otros paquetes  </h4>
            </div>
            <div class="resumen_content" >
              <h4>
                  {{dataPackage.attributes.items_from_reposition}}</h4>
            </div>
          </div>
        </div>

        <div class="modal-footer text-center">
          <button
            type="button"
            class="btn btn-primary btn-lg"
            @click="hideModalDetailReposition()"
          >cerrar</button>
        </div>
      </div>
    </b-modal>
  </div>

</template>

<script>
import breadcrumb from '@/components/prefab/structures/breadcrumb.vue'

import { packagesService } from '@/services/packages.service'

export default {
  components: {

    breadcrumb
  },
  props:['id'],
  data(){
    return{


      dataPackage:'',
      isLoading:false,
      packageRepositions:[],
      deficitPackageRepositions:[],

      nameSection: 'Visualizar Paquete',
      listRoutes: [{ nameRoute: 'Orders', titleRoute: 'Órdenes de compra' },
                   { nameRoute: 'show-purchase-order', titleRoute: 'Visualizar orden de compra', idRoute: '' }
                  ],
      activeRoute: '',
    }
  },
  created(){
    packagesService.getPackageDetail(this.id,this.setDataPackage)
  },
  methods:{
   setDataPackage(packageFromServer){
     this.dataPackage = packageFromServer
     this.listRoutes[1].idRoute = this.dataPackage.attributes.purchaseOrder.id;
     this.activeRoute = 'Paquete Nro.#' + this.dataPackage.attributes.package_name;
   },
   setPackageRepositionsDetail(packageRepositionsFromServer){
     this.showModalDetailReposition();
     this.packageRepositions = packageRepositionsFromServer
     console.log("puso los package repositions");

   },
   setDeficitIncidentPackageRepositionsDetail(deficitPackageRepositionsFromServer){
     this.deficitPackageRepositions = deficitPackageRepositionsFromServer
     console.log("puso los package repositions deficit");
   },
   showRepositionItemsDetail(){
      console.log("Estamos en show");

      packagesService.getPackageRepositionsDetail(this.id, this.setPackageRepositionsDetail)
      

   },

   showDeficitIncidentItemsDetail(deficitIncidentId){
      console.log("Estamos en show 2");
      console.log(deficitIncidentId);


      packagesService.getPackageRepositionsByDeficitIncidentId(deficitIncidentId, this.setDeficitIncidentPackageRepositionsDetail)
      this.showModalDetailItemsFail();
   },

   hideModalDetailItemsFail() {
     this.$refs.modalDetailItemsFail.hide()
   },
   showModalDetailItemsFail() {
     this.$refs.modalDetailItemsFail.show()
   },
   hideModalDetailReposition() {
     this.$refs.modalDetailReposition.hide()
   },
   showModalDetailReposition() {
     this.$refs.modalDetailReposition.show()
   },
   backPage() {
     this.$router.go(-1)
   },

  },

  computed:{
    deficitItems(){
        
        let incidents = this.dataPackage.attributes.incidents
        let deficitItems = 0
        incidents.forEach(incident => {
            if (incident.attributes.clusterable_type == 'different_quantity' &&  
              incident.attributes.clusterable.attributes.delta_type==1){
                deficitItems += (parseInt(incident.attributes.clusterable.attributes.total_items)- parseInt(incident.attributes.clusterable.attributes.correct_items))
            }
            
        });

       

        return deficitItems


    },
  }

}
</script>



// WEBPACK FOOTER //
// package-show-view.vue?8fcc41bc